import { render, staticRenderFns } from "./d-parallax.vue?vue&type=template&id=49fdd904&scoped=true&lang=pug&"
import script from "./d-parallax.vue?vue&type=script&lang=js&"
export * from "./d-parallax.vue?vue&type=script&lang=js&"
import style0 from "./d-parallax.vue?vue&type=style&index=0&id=49fdd904&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fdd904",
  null
  
)

export default component.exports